<div [formGroup]="form" class="formulaire">
  <div class="row">
    <div class="col-12">
      <!-- Encadré Rappel seuils de dispense -->
      <div class="rappel-box" *ngIf="!isReliable()">
        <p>
          <span class="rappel-label">Rappel :</span> depuis le 1<sup>er</sup> avril 2026, les seuils de dispense de publicité et de mise en concurrence préalables sont modifiés :
        </p>
        <ul>
          <li>
            Pour les marchés de fournitures ou de services : initialement fixé à 40&nbsp;000&nbsp;€ hors taxes (HT), le seuil est porté à 60&nbsp;000&nbsp;€ hors taxes (HT).
          </li>
          <li>
            Pour les marchés de travaux : la dispense s'applique lorsque la valeur estimée du marché est inférieure à 100&nbsp;000&nbsp;€ hors taxes (HT).
          </li>
        </ul>
      </div>

      <!-- choix des formulaires-->
      <div class="col-12 d-block" *ngIf="!isReliable()">
        <h3 role="heading" aria-level="1">{{ choixFormulaire.libelleCritere | translate }}</h3>
        <p><span>Je cherche un formulaire pour </span></p>
          <p><span>un <label for="typeOrganisme"><strong>type d'organisme</strong></label> : *
            <select #selectField [name]="'typeOrganisme'" id="typeOrganisme" (change)="actualiseMarche()" [formControlName]="'typeOrganisme'" style="width: 450px;">
              <option *ngFor="let orga of listTypeOrga" [value]="orga.code">
                {{ orga.libelle }}
              </option>
            </select>
          </span>
          </p>
          <p *ngIf="getTypeOrganisme() !== undefined"><span>un <label for="typeMarche"><strong>domaine du contrat</strong></label> : *</span>
          <select [name]="'typeMarche'" id="typeMarche" (change)="actualiseMontant()" [formControlName]="'typeMarche'" style="width: 350px;">
            <option *ngFor="let marche of listTypeMarche" [value]="marche.code">
              {{ marche.libelle }}
            </option>
          </select>
          </p>
          <p *ngIf="getTypeOrganisme() !== undefined && getTypeMarche() !== undefined"><span>d'un <label for="montantMarche"><strong>montant du marché</strong></label> : *</span>
          <select [name]="'montantMarche'" id="montantMarche" (change)="actualiseAvis()" [formControlName]="'montantMarche'" style="width: 200px;">
            <option *ngFor="let montant of listTypeMontant" [value]="montant.code">
              {{ montant.libelle }}
            </option>
          </select>,
          </p>
          <p *ngIf="getTypeOrganisme() !== undefined && getTypeMarche() !== undefined && getMontantMarche() !== undefined"><span>un <label for="typeAvis"><strong>type d'avis</strong></label> : *</span>
          <select [name]="'typeAvis'" id="typeAvis" [formControlName]="'typeAvis'" style="width: 400px;">
            <option *ngFor="let avis of listTypeAvis" [value]="avis.code">
              {{ avis.libelle }}
            </option>
          </select>
          </p>
      </div>

      <div *ngIf="!isReliable()" class="d-flex">
        <div class="p-2">
          <button (click)="resetFields()" [disabled]="isFieldDisabled()" class="btn btn-outline-primary">{{
            choixFormulaire.resetFields | translate }}
          </button>
        </div>
        <div class="ml-auto p-2">
          <button (click)="getForms()" [disabled]="isButtonDisabled()" class="btn btn-outline-primary">{{
            choixFormulaire.search | translate }}
          </button>
        </div>
      </div>

      <!-- Avis references dropdown list-->
      <select *ngIf="isChoixFormulaire && isReliable()" (change)="getSelectedAvisReference($event.target)">
        <option *ngIf="!isRelie()" disabled hidden selected value> -- Avis parent -- </option>
        <option *ngFor="let ref of references" [value]="ref">
          {{ref}}
        </option>
      </select>

      <!--Tableau des formulaires-->
      <div class="col-12 d-block">
        <div class="line">
          <h3 class="title" role="heading" aria-level="1">{{ choixFormulaire.libelleChoix | translate }}</h3>
          <div class="ml-auto">
            <app-bottom-page></app-bottom-page>
          </div>
        </div>
        <app-tableau class="d-block" (actionEvent)="getActionEvent($event)" [tableContent]="tableContent"
          [sortingColumn]="sortingColumn" [isChoixFormulaire]="isChoixFormulaire">
        </app-tableau>
        <div class="line">
          <div class="ml-auto">
            <app-top-table-page></app-top-table-page>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
